import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import {
  EmotionThemeProvider,
  ThemeProvider,
  theme,
} from '@yuno/design-system-web'
import { config } from '../common/config'

function AuthProvider({ children }) {
  return (
    <EmotionThemeProvider theme={theme}>
      <ThemeProvider theme={theme}>
        <Auth0Provider
          domain={config[`AUTH0_DOMAIN_${process.env.ENVIRONMENT}`]}
          clientId={config[`AUTH0_CLIENT_ID_${process.env.ENVIRONMENT}`]}
          redirectUri={`${window.location.origin}`}
          audience={config[`AUTH0_CLIENT_AUDIENCE_${process.env.ENVIRONMENT}`]}
          scope={process.env.AUTH0_CLIENT_SCOPE}
        >
          {children}
        </Auth0Provider>
      </ThemeProvider>
    </EmotionThemeProvider>
  )
}

export { AuthProvider, useAuth0 }
